import { z } from "zod";
import { DmaSettingParameterKind } from "./dma-setting-parameter-kind.schema";
export const dmaSettingStringParameterDtoSchema = z.object({
    kind: z.literal(DmaSettingParameterKind.String),
    name: z.string(),
    value: z.string(),
});
